import Vue from 'vue'
import i18n from './i18n'

const globalLightVue = new Vue({i18n})
export default globalLightVue